module.exports = __webpack_public_path__ + "assets/1bb5d8b7a30d0a6fd83826283bb42470.mp4";